<template>
  <!-- <div class="viewer" :id='viewer'>
         <img src='$factoryLink' /> 
    </div> -->
  <div id="main">
    <!-- <img src='../../../assets/quanjing.jpg'/> -->
    <div id="viewer1" v-show="this.pshow">
      <!-- <h2 style="text-align: center">欢迎来到服务厅全景图</h2>
      <p style="font-size: 16px; margin: 0px; padding: 0px">目前经纬度</p>
      <div style="float: left">
        <p style="font-size: 12px; margin: 0px; padding: 0px">经度：</p>
        <span style="font-size: 12px; float: left" id="long"></span>
      </div>
      <div style="float: right">
        <p style="font-size: 12px; margin: 0px; padding: 0px">纬度：</p>
        <span style="font-size: 12px" id="lat"></span>
      </div> -->
      <!-- <button @click="initPhotoSphere">显示全景图</button> -->
    </div>

    <div class="views_img">
      <div class="views_box" @click="getViews">
        <img
          src="../../../assets/video.png"
          alt=""
          v-if="voice"
          @click="playAudio()"
        />

        <img
          src="../../../assets/noVideo.png"
          alt=""
          v-else
          @click="noPlayAudio()"
        />
      </div>
      <audio
        :src="vrAudio"
        id="eventAudio"
        preload="auto"
        controls
        loop
        hidden="true"
      ></audio>

      <div class="views_box" @click="getImgs">
        <img src="../../../assets/imgs.png" alt="" />
      </div>
    </div>
    <div class="allImgs flex" v-if="allImgsShow">
      <div
        class="allImgs_box_imgs"
        v-for="(items, index) in vrList"
        :key="index"
        @click="getVrImage(items.url)"
      >
        <img :src="items.url" alt="" />
        <p>{{ items.name }}</p>
      </div>
    </div>
    <div class="allImgs_top" v-if="allImgsTopShow">
      <div class="allImgs_box_imgs" @click="getAllTopImgs">
        <img src="" alt="" />
        <p>图片名称</p>
      </div>
    </div>
  </div>
</template>

<script>
// import PhotoSphereViewer from 'photo-sphere-viewer'
import { getParkEnterpriseDetail } from "../../../utils/interface";
import { Viewer } from "photo-sphere-viewer";
import MarkersPlugins from "photo-sphere-viewer/dist/plugins/markers";
import AutorotateKeypointsPlugin from "photo-sphere-viewer/dist/plugins/autorotate-keypoints";
import "photo-sphere-viewer/dist/photo-sphere-viewer.css";
import { mapMutations, mapState } from "vuex";

// import * as Three from 'three'

//     var THREE   = require('three');
//     var PhotoSphereViewer   = require('photo-sphere-viewer');
export default {
  data() {
    return {
      vrImageUrl: "",
      vrAudio: "",
      vrIndex: 0, //初始角标为 0
      viewers: null, // 创建VR实例
      pshow: true,
      use: true,
      psv: "",
      id: "",
      vrImage: "",
      vrList: [],
      readyLoad: "",
      imageLoaded: "",
      longitude: "", //目前经度
      latitude: "", //目前纬度
      marker3: require("../../../assets/logo.png"),
      imageloading: [
        {
          marker: [
            {
              id: "image1",
              //   image: require("../../../assets/pin1.png"),
              width: 35,
              height: 35,
              longitude: 10,
              latitude: 100,
              anchor: "bottom center",
              className: "markers",
              //   tooltip: {
              //     content: "欢迎进入下一场景",
              //     position: "bottom left",
              //   },
              visible: true,
            },
          ],
        },
      ],
      voice: true,
      allImgsShow: false,
      allImgsTopShow: false,
      parkHeight: "",
      setIn: null,
    };
  },
  created() {
    this.id = this.$route.params.uuid;

    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getParkEnterpriseDetail();
      }
    }, 500);

    this.vuexAllPark(false);
    this.parkHeight = document.documentElement.clientHeight;
    console.log(this.parkHeight);
  },
  mounted() {
    // markersPlugin.on("select-marker", (e, marker) => {
    //   console.log(marker.id);
    //   const markerid = marker.id;
    // });
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  methods: {
    ...mapMutations(["vuexAllPark"]),
    playAudio() {
      let buttonAudio = document.getElementById("eventAudio");
      buttonAudio.play();
    },

    noPlayAudio() {
      let buttonAudio = document.getElementById("eventAudio");
      buttonAudio.pause()();
    },

    getParkEnterpriseDetail() {
      getParkEnterpriseDetail(this.id).then((res) => {
        console.log(res);
        this.vrImage = res.vrImage;
        this.vrList = res.vrList;
        this.vrAudio = res.vrAudioUrl;
        this.getVrImage(this.vrList[this.vrIndex].url);
      });
    },

    getVrImage(url) {
      this.vrImageUrl = url;
      this.initPhotoSphere(this.imageloading[0]);
    },

    initPhotoSphere: function (temp_img) {
      let that = this;
      document.getElementById("viewer1").innerHTML = "";

      const viewers = new Viewer({
        // Container 容器
        container: document.getElementById("viewer1"),
        // Panorama, given in base 64
        // 全景的图片
        panorama: this.vrImageUrl,
        // // Deactivate the animation
        // time_anim: false, // 在多少毫秒内开始自动播放
        // anim_speed: '0.4rpm', // 自动旋转速度， 默认是2rpm

        // loading_img: this.img,
        //enabled: 'false',
        // caption: "珠海移动营业厅", // 给图片加说明
        // Display the navigation bar
        navbar: true,
        // navbar: [
        //   {
        //     id: "my-button", //按钮的唯一标识符，在使用该navbar.getButton()方法时很有用
        //     content: "Custom", //必需的,按钮内容
        //     title: "Hello world", //鼠标悬停在按钮上时显示工具提示
        //     className: "custom-button", //CSS类已添加到按钮
        //     onClick: () => {
        //       console.log(33333) //必需的,单击按钮时调用的函数
        //     },
        //     //disabled:false,最初禁用该按钮
        //     //hidden:false,最初隐藏按钮
        //   },
        // ],
        size: {
          width: "100%",
          //   height:'500px'
          height: that.parkHeight + "px",
        },
        plugins: [[AutorotateKeypointsPlugin]],
      });
      this.viewers = viewers;
      //   viewers.on("position-updated", function (po) {
      //     var span1 = document.getElementById("long");
      //     span1.innerHTML = po.args[0].longitude;

      //     var span2 = document.getElementById("lat");
      //     span2.innerHTML = po.args[0].latitude;
      //   });

      const markersPlugin = viewers.getPlugin(MarkersPlugins);
      // this.imageloading[1].marker 把索引传过来
      /* markersPlugin.on("select-marker", (e, marker) => {
        if (marker.id == "image1") {
          // alert(e);
          // this.pshow = false;
          // this.use = true;
          viewers.setPanorama(require("../../../assets/0400.jpg")).then(() => {
            markersPlugin.setMarkers(this.imageloading[0].marker);

            markersPlugin.on("select-marker", (e, marker) => {
              if (marker.id == "image3") {
                viewers.setPanorama(this.imageloading[0].imgurl).then(() => {
                  markersPlugin.setMarkers(this.imageloading[0].marker);
                });
              }
            });
          });
        }
        if (marker.id == "image2") {
          //  alert(e);
          viewers.setPanorama(require("../../../assets/0200.jpg")).then(() => {
            markersPlugin.setMarkers(this.imageloading[1].marker);

            markersPlugin.on("select-marker", (e, marker) => {
              if (marker.id == "image3") {
                viewers.setPanorama(this.imageloading[0].imgurl).then(() => {
                  markersPlugin.setMarkers(this.imageloading[0].marker);
                });
              }
            });
          });
        }
      });*/
    },
    // changeinitPhotoSphere(temp_img){
    //     // if(this.viewers1 != ''){
    //     //     this.viewers1.destory();
    //     // }
    //         const viewers1=new Viewer({
    //         // Container
    //         container: document.getElementById('viewer1'),
    //         // Panorama, given in base 64
    //         panorama: temp_img.imgurl,
    //         // // Deactivate the animation
    //         // time_anim: false,

    //         // loading_img: this.img,
    //         // enabled: 'false',
    //         caption: '珠海移动营业厅',
    //         // Display the navigation bar
    //         navbar:true,
    //         size: {
    //             width: '100%',
    //             height: this.isMobile()? screen.availHeight : '100%'
    //         },
    //         plugins: [
    //             [MarkersPlugins,{
    //                 // time_anim: false,
    //                 // fisheye:true,
    //                 scale: 1,
    //             markers:temp_img.marker
    //             }],
    //         ],
    //     });
    //     const markersPlugin1 = viewers1.getPlugin(MarkersPlugins);
    //     markersPlugin1.on('select-marker', (e, marker) => {
    //         if(marker.id=='image3') {
    //             viewers1.setPanorama(require('../../../assets/0400.jpg')).then(() => {
    //                 viewers1.destory();
    //                 this.initPhotoSphere(this.imageloading[0]);
    //             });
    //         }
    //     });
    // },
    isMobile() {
      let ua = navigator.userAgent;

      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;
      return isMobile;
    },
    getViews() {
      this.voice = !this.voice;
    },
    getImgs() {
      this.allImgsShow = !this.allImgsShow;
      if (this.allImgsShow == false) {
        this.allImgsTopShow = false;
      }
    },

    getAllImgs(url) {
      this.allImgsTopShow = true;
      console.log(url);
      this.vrImageUrl = url;
    },
    // 点击切换大图的展示
    getAllTopImgs() {
      console.log("打印");
      this.viewers.setPanorama(this.vrImageUrl).then(() => {
        console.log("-------替换图片完成--------");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.hi {
  color: red;
  font-size: 20px;
  text-align: left;
}
#main {
  position: relative;
  /deep/ .psv-container {
    height: 100% !important;
  }
  /deep/ .psv-markers-list-button {
    display: none;
  }
  .views_img {
    position: absolute;
    top: 1rem;
    right: 1rem;
    .views_box {
      width: 2rem;
      height: 2rem;
      background: rgba(0, 0, 0, 0.221);
      border-radius: 50%;
      padding: 0.5rem;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .views_box:nth-child(1) {
      margin-bottom: 0.5rem;
    }
  }
}
.allImgs {
  background: rgba(0, 0, 0, 0.221);
  width: 100%;
  height: 100px;
  padding: 20px 0;
  position: absolute;
  bottom: 52px;
  .allImgs_box_imgs {
    width: 100px;
    height: 100px;
    background: #fff;
    position: relative;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      background: rgba(0, 0, 0, 0.221);
      font-size: 13px;
      color: #fff;
    }
  }
}
.allImgs_top {
  background: rgba(0, 0, 0, 0.221);
  width: 100%;
  height: 100px;
  padding: 20px 0;
  position: absolute;
  bottom: 200px;
  .allImgs_box_imgs {
    width: 100px;
    height: 100px;
    background: #fff;
    position: relative;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    p {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      background: rgba(0, 0, 0, 0.221);
      font-size: 13px;
      color: #fff;
    }
  }
}
</style>
   


// WEBPACK FOOTER //
// src/components/park/allMap/enterpriseVeiws.vue